import type React from 'react';
import { memo } from 'react';

import { BusyIcon, isBusyNow, isConfirmed, useSchedule, useTz } from '@entities/schedules';
import cn from 'classnames';

import { getSessionBlock } from '@shared/helpers';

import { BusyContent } from '../busy-content';
import { BusyStartTime } from '../busy-start-time';
import { BusyVisitor } from '../busy-visitor';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	start: Date;
	end: Date;
	scheduleId: number;
}

export const BusyDaySession: React.FC<Props> = memo(({ start, end, scheduleId, ...props }) => {
	const { schedule } = useSchedule(scheduleId);
	const { tz } = useTz();

	const blockType = getSessionBlock({ start, end }, tz, schedule?.start_time, schedule?.end_time);

	const isNow = isBusyNow(schedule);

	const confirmed = isConfirmed(schedule);
	return (
		<div className={cn(st.session, st[blockType], isNow && st.now)} {...props}>
			<BusyStartTime start={start} end={end} scheduleId={scheduleId} />
			<BusyContent start={start} end={end} scheduleId={scheduleId}>
				<BusyIcon id={scheduleId} />
				<BusyVisitor id={scheduleId} />
				{!confirmed && <span className={st.session__unconfirmed}>Не подтверждена</span>}
			</BusyContent>
		</div>
	);
});
